// src/components/Products/ProductsSection.js
import React, { useState, useMemo } from "react";
import { products, categories } from "../../data/products";
import ProductCard from "./ProductCard";
import "./ProductsSection.css";

export default function ProductsSection() {
  const [activeCategory, setActiveCategory] = useState("all");
  const [sort, setSort] = useState("trending");
  const [priceMax, setPriceMax] = useState(3000);
  const [showFilters, setShowFilters] = useState(false);

  const filtered = useMemo(() => {
    let list = activeCategory === "all"
      ? products
      : products.filter(p => p.category === activeCategory);
    list = list.filter(p => p.price <= priceMax);
    switch (sort) {
      case "price-low": return [...list].sort((a, b) => a.price - b.price);
      case "price-high": return [...list].sort((a, b) => b.price - a.price);
      case "rating": return [...list].sort((a, b) => b.rating - a.rating);
      case "discount": return [...list].sort((a, b) => (b.mrp - b.price) - (a.mrp - a.price));
      case "newest": return [...list].sort((a, b) => b.id - a.id);
      default: return list;
    }
  }, [activeCategory, sort, priceMax]);

  return (
    <section className="products-section">
      {/* Category pills – exact TSS style */}
      <div className="category-pills-wrap">
        <div className="category-pills">
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`category-pill ${activeCategory === cat.id ? "category-pill--active" : ""}`}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {/* Filter bar */}
      <div className="products-filter-bar">
        <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span className="products-count">{filtered.length} Products</span>
          <div style={{ display: "flex", gap: 10 }}>
            <button className="filter-btn" onClick={() => setShowFilters(!showFilters)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                <line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/>
              </svg>
              FILTER
            </button>
            <select className="sort-select" value={sort} onChange={e => setSort(e.target.value)}>
              <option value="trending">Sort: Trending</option>
              <option value="newest">Newest First</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="rating">Customer Rating</option>
              <option value="discount">Best Discount</option>
            </select>
          </div>
        </div>
        {showFilters && (
          <div className="filter-panel container">
            <div className="filter-group">
              <label className="filter-label">Max Price: ₹{priceMax.toLocaleString()}</label>
              <input type="range" min="500" max="3000" step="100"
                value={priceMax} onChange={e => setPriceMax(+e.target.value)}
                style={{ width: 200, accentColor: "var(--tss-teal)" }} />
              <div style={{ display: "flex", justifyContent: "space-between", width: 200, fontSize: 11, color: "var(--tss-gray-400)", marginTop: 3 }}>
                <span>₹500</span><span>₹3000</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Products grid */}
      <div className="container">
        <div className="products-grid">
          {filtered.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
        {filtered.length === 0 && (
          <div className="products-empty">
            <span>😔</span>
            <p>No products found. Try adjusting the filters.</p>
          </div>
        )}
        {filtered.length > 0 && (
          <div className="products-loadmore">
            <button className="loadmore-btn">LOAD MORE</button>
          </div>
        )}
      </div>
    </section>
  );
}
